module.exports = __webpack_public_path__ + "static/media/arbitrum.a10a03ad.svg";